/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import StatusInfoIcon from '@atlaskit/icon/core/status-information';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import { token } from '@atlaskit/tokens';
import { FlagAction } from '@atlassian/connect-module-core/src/modules/flag/FlagCreationOptions';

export interface Icons {
  generic: JSX.Element;
  info: JSX.Element;
  hint: JSX.Element;
  success: JSX.Element;
  warning: JSX.Element;
  error: JSX.Element;
}

export const iconMap = (key: keyof Icons) => {
  const icons = {
    generic: <StatusInfoIcon label="Generic" color={token('color.icon')} />,
    info: (
      <StatusInfoIcon label="Info" color={token('color.icon.information')} />
    ),
    hint: <StatusInfoIcon label="Hint" color={token('color.icon.discovery')} />,
    success: (
      <CheckCircleIcon label="Success" color={token('color.icon.success')} />
    ),
    warning: (
      <StatusWarningIcon label="Warning" color={token('color.icon.warning')} />
    ),
    error: <StatusErrorIcon label="Error" color={token('color.icon.danger')} />,
  };
  return icons[key];
};

export function getIcon(key: keyof Icons) {
  return iconMap(key);
}

export function wrapAction(action: FlagAction) {
  return {
    content: action.actionText,
    onClick: (() => action.executeAction()) as (...args: Array<any>) => any,
  };
}
